import * as yup from 'yup';

export default function stringMinMaxRequired(label, min, max) {
  return yup.string().min(min).max(max).label(label).required();
}
